module.exports = __webpack_public_path__ + "img/arrow-up-white.a35ee8e0.svg";